import { render, staticRenderFns } from "./AlignInput.vue?vue&type=template&id=7ce3b8fa&scoped=true"
import script from "./AlignInput.vue?vue&type=script&lang=js"
export * from "./AlignInput.vue?vue&type=script&lang=js"
import style0 from "./AlignInput.vue?vue&type=style&index=0&id=7ce3b8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce3b8fa",
  null
  
)

export default component.exports